<template>
    <v-container fluid style="height: 100%;">

        <v-row align="center" justify="center" style="height: 100%;">
          <v-col cols="12" sm="6" md="4">
            <div class="text-center">
                <v-progress-circular
                :size="70"
                :width="7"
                color="amber"
                indeterminate
                ></v-progress-circular>
            </div>
          </v-col>
        </v-row>

      </v-container>
</template>

<script>
import Parse from 'parse'

export default {
    data() {
        return {
            self: ''
        }
    },

    mounted() {
        this.$store.state.barActive = false
        this.createSession(this);
    },

    methods: {
        createSession(self){
            if (this.$route.params.token) {
                Parse.User.become(this.$route.params.token).then(function (user) {
                    self.$snotify.success(`Bienvenido ${user.attributes.name}` , 'Sesión', {
                        timeout: 4000,
                        preventDuplicates: true
                    });

                    if (self.$route.params.report) {
                        window.location.href = "/mystore/mobile/" + self.$route.params.store_id
                    }else{
                        window.location.href = "/mystore-invoices/" + self.$route.params.store_id
                    }

                }, function (error) {
                    self.$swal({
                        title: "Sesión",
                        text: `Error al tratar de establecer la sesión.`,
                        icon: "warning",
                        buttons: ['Salir', 'Entiendo'],
                        dangerMode: true,
                    }).then((ok) => {
                        if (ok) {
                            self.$router.push('/')
                        }else{
                            self.$router.push('/')
                        }
                    });
                    //eslint-disable-next-line
                    console.log(error);
                });

            }else{
                this.$router.push('/')
            }
        }
    },
}
</script>